import { Box, Button, CircularProgress, Divider, InputLabel, Modal, Switch, Typography } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import "./styles.css";
import { formatToIndianCurrency } from "../../../utils/utilityFunctions";
import { CloseIcon, DeleteIcon } from "../../customSVGs";
import { useState, useEffect } from "react";
import { GetAccountType, PostRecommendedSchemes, SchemeList } from "../../../redux-store/types/api-types";
import Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import { formatLongDate } from "../../../utils/date";
import { useDispatch } from 'react-redux';
import { getRmDetails, get_account_type, get_recommendation_validation, post_recommended_schemes } from "../../../redux-store/actions/userManagement";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Key } from "@mui/icons-material";
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


export function SubFundCategoryCard(
  { onSchemeSelection, schemeDetail, OnSchemeDeSelection, handleSetViewSchemeDetails, allocation, selectedSchemes, openModal }:
    {
      onSchemeSelection: (schemeId: number) => void;
      schemeDetail: SchemeList;
      OnSchemeDeSelection: (schemeId: number) => void;
      handleSetViewSchemeDetails: (val: boolean, schemeDetail: SchemeList) => void;
      allocation: boolean;
      selectedSchemes: SchemeList[];
      openModal: boolean;
    }
) {
  const [schemeSelected, setSchemeSelected] = useState<boolean>(false);

  const handleSchemeCheckboxChange = (e: any) => {
    if (e.target.checked == true) {
      onSchemeSelection(schemeDetail.SchemeID);
      setSchemeSelected(true);
    }
    else {
      OnSchemeDeSelection(schemeDetail.SchemeID);
      setSchemeSelected(false);
    }
  }

  useEffect(() => {
    if (!selectedSchemes.includes(schemeDetail)) {
      setSchemeSelected(false);
    }
  }, [openModal])
  const plan =
    schemeDetail.Growthoption === 1
      ? "Growth"
      : schemeDetail.Dividendreinvestment === 1
        ? "Div"
        : schemeDetail.DividendPayout === 1
          ? "Div"
          : "";
  const subPlan =
    schemeDetail.Dividendreinvestment === 1
      ? "Reinvestment"
      : schemeDetail.DividendPayout === 1
        ? "Payout"
        : "";

  const categoryValue = schemeDetail.Cat_Return5yr;
  const selectedValue = schemeDetail.Sch_Return5Yr;

  function roundToTwo(num: number) {
    const num2 = num + "e+2";

    return +(Math.round(Number(num2)) + "e-2");
  }

  const Nanprocessor = function (entry: any) {
    if (entry) {
      return entry;
    } else {
      return 0;
    }
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', my: 2.5 }}>
        <Box sx={{ width: '10%' }}>
          <Checkbox sx={{ color: '#337FC9', mx: 1.5 }} onChange={handleSchemeCheckboxChange} checked={schemeSelected} />
        </Box>
        <Box sx={{ marginRight: 10, display: 'flex', flexDirection: 'column', width: "25%" }}>
          <Typography sx={{ fontSize: 14, fontWeight: 500, mb: 0.5 }}>
            {schemeDetail.SchemeName}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: "wrap" }}>
            {!!schemeDetail.AssetClassName && (
              <Bubble text={schemeDetail.AssetClassName} />
            )}
            {!!schemeDetail.Sub_AssetclassName && (
              <Bubble text={schemeDetail.Sub_AssetclassName} />
            )}
            {!!plan && <Bubble text={plan} />}
            {subPlan.length !== 0 && <Bubble text={subPlan} />}
            {!!subPlan && !!schemeDetail.Dividendfrequency && (
              <Bubble text={schemeDetail.Dividendfrequency} />
            )}
          </Box>
        </Box>
        <Box sx={{ width: "15%" }}>
          <Typography sx={{ fontSize: 14, color: '#5a7c82' }}>AUM</Typography>
          <Typography sx={{ fontSize: 16 }}>
            {schemeDetail.Aum === "0" || !schemeDetail.Aum
              ? "NA"
              : formatToIndianCurrency(schemeDetail.Aum, 1)}
          </Typography>
        </Box>

        <Box sx={{ width: "17%", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography sx={{ fontSize: 14, color: '#5a7c82' }}>
            {!allocation ? "Category Avg Returns" : "Allocation"}
          </Typography>
          <Typography sx={{ fontSize: 16, color: "rgb(30, 163, 98)" }}>
            {" "}
            {`${Nanprocessor(roundToTwo(Number(categoryValue)))}%`}
          </Typography>
        </Box>

        <Box sx={{ width: "15%", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography sx={{ fontSize: 14, color: '#5a7c82' }}>Returns</Typography>
          <Typography sx={{ fontSize: 16, color: "rgb(30, 163, 98)" }}>
            {selectedValue === "0" || !selectedValue
              ? "NA"
              : `${Nanprocessor(roundToTwo(Number(selectedValue)))}%`}
          </Typography>
        </Box>
        <Box sx={{ width: '8%' }}>
          <ArrowForwardIosIcon onClick={() => { handleSetViewSchemeDetails(true, schemeDetail); }} sx={{ borderRadius: 1, backgroundColor: '#337FC9', color: '#ffffff', p: 0.2, mx: 1.5 }} />
        </Box>
      </Box>

    </div>
  )
}

export function Bubble(props: { text: string }) {
  return (
    <div className="bubbleDiv">
      <div className="bubbleText">
        {props.text}
      </div>
    </div>
  );
}

function roundToTwo(num: number) {
  const num2 = num + "e+2";

  return +(Math.round(Number(num2)) + "e-2");
}

const Nanprocessor = function (entry: any) {
  if (entry) {
    return entry;
  } else {
    return 0;
  }
};

interface schemeParams {
  SchemeID: number;
  SchemeName: string;
  Aum: string;
  Sch_Return5Yr: number;
  minPurchase: any;
  maxPurchase: any;
  switchValue: string;
  invAmount: number;
  selectedAccount: string;
  instalmentAmount: number;
  error: boolean;
  errorInstalment: boolean;
  errorSIPDay: boolean;
  errorAccountLumpsum: boolean;
  errorAccountSIP: boolean;
  errorMessageAccount: string;
  errorFrequency: boolean;
  errorInstalmentAmount: boolean;
  errorMessage: string;
  errorMessageInstalment: string;
  errorMessageSIPDay: string;
  errorMessageFrequency: string;
  errorMessageInstalmentAmount: string;
  AssetClassName: string;
  Sub_AssetclassName: string;
  Dividendfrequency: string;
  Growthoption: number;
  Dividendreinvestment: number;
  DividendPayout: number;
  instalments: number;
  SIPDay: string;
  // mandate: string;
  frequency: string;
  Sch: any;
  datePicker: any;
}

interface sipSchemeValidation {
  Productcode_RTA: string,
  SIPFREQUENCY: string | null,
  SIPDATES: string,
  SIPMINIMUMINSTALLMENTAMOUNT: string,
  SIPMAXIMUMINSTALLMENTAMOUNT: string,
  SIPMINIMUMINSTALLMENTNUMBERS: string,
  SIPMAXIMUMINSTALLMENTNUMBERS: string,
  SCHEMEISIN: string,
  SIPMINIMUMGAP: string,
  IPMAXIMUMGAP: string,
  SIPMULTIPLIERAMOUNT: string
}

export function RecommendedSchemesModal({ handleModalClose, selectedSchemes, OnSchemeDeSelection, investorId, isRecommended }:
  { handleModalClose: () => void; selectedSchemes: SchemeList[] | undefined; OnSchemeDeSelection: (schemeId: number) => void; investorId: string; isRecommended: (val: boolean) => void }) {

  const [schemeParams, setSchemeParams] = useState<schemeParams[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rmId, setRmId] = useState<number | null>();
  const [accountType, setAccountType] = useState<GetAccountType | null>();
  const [validations, getValidations] = useState<any>();
  const [SIPInstallment, setSIPInstallment] = useState<sipSchemeValidation[]>();
  const [selectedAccountType, setSelectedAccountType] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());


  const dispatch = useDispatch();
  useEffect(() => {
    const schemeParams: any = [];
    selectedSchemes?.map((item) => {
      const swtVal = {
        SchemeID: item.SchemeID,
        SchemeName: item.SchemeName,
        Aum: item.Aum,
        Sch_Return5Yr: item.Sch_Return5Yr,
        minPurchase: item.MinimumPurchaseAmount,
        maxPurchase: item.MaximumPurchaseAmount,
        switchValue: "Lumpsum",
        instalmentAmount: null,
        invAmount: null,
        selectedAccount: "",
        error: false,
        errorInstalment: false,
        errorSIPDay: false,
        errorFrequency: false,
        errorInstalmentAmount: false,
        errorMessage: "",
        errorMessageInstalment: "",
        errorMessageSIPDay: "",
        errorMessageFrequency: "",
        errorMessageInstalmentAmount: "",
        AssetClassName: item.AssetClassName,
        Sub_AssetclassName: item.Sub_AssetclassName,
        Dividendfrequency: item.Dividendfrequency,
        Growthoption: item.Growthoption,
        Dividendreinvestment: item.Dividendreinvestment,
        DividendPayout: item.DividendPayout,
        instalments: null,
        SIPDay: "",
        mandate: "",
        frequency: null,
        Sch: item.Sch
      }
      // console.log(selectedSchemes.Dividendfrequency)
      schemeParams.push(swtVal);
    })
    setSchemeParams(schemeParams);
  }, [])

  useEffect(() => {

    let isComponentActive = true;
    setRmId(null);
    (async function () {
      try {
        const response = (await dispatch(
          getRmDetails()
        )) as unknown as any;
        if (!isComponentActive) {
          return;
        }
        setRmId(response.Header_ID);

      } catch (e) {
        console.log((e as Error).message);
      }
    })();

    return () => {
      isComponentActive = false;
    };
  }, [])
  useEffect(() => {

    let isComponentActive = true;
    setAccountType(null);
    (async function () {
      try {
        const response = (await dispatch(
          get_account_type({
            rmID: rmId,
            ClientCode: investorId
          })
        )) as unknown as GetAccountType;
        if (!isComponentActive) {
          return;
        }
        setAccountType(response);
      } catch (e) {
        console.log((e as Error).message);
      }
    })();

    return () => {
      isComponentActive = false;
    };
  }, [])

  useEffect(() => {
    const temp: any = [];
    const validationList: any = [];
    console.log(selectedSchemes)
    selectedSchemes?.map(async (item: SchemeList) => {
      console.log(item.Sch)
      const obj = await recommendation_val(item.Sch);
      console.log(obj)
      temp.push({
        [item.Sch]: (obj.validations[1] as any),
      });
      validationList.push({
        Productcode_RTA: item.Sch,
        SIPFREQUENCY: null,
        SIPDATES: "",
        SIPMINIMUMINSTALLMENTAMOUNT: "",
        SIPMAXIMUMINSTALLMENTAMOUNT: "",
        SIPMINIMUMINSTALLMENTNUMBERS: "",
        SIPMAXIMUMINSTALLMENTNUMBERS: "",
        SCHEMEISIN: "",
        SIPMINIMUMGAP: "",
        IPMAXIMUMGAP: "",
        SIPMULTIPLIERAMOUNT: ""
      });
    })
    console.log(temp)
    getValidations(temp);
    setSIPInstallment(validationList);
  }, [selectedSchemes])

  const recommendation_val = async (sch: any): Promise<any> => {
    const isComponentActive = true;
    try {
      const response = (await dispatch(
        get_recommendation_validation({ sch, TrType: "SIP" })
      )) as any;
      if (!isComponentActive) {
        return Promise.resolve();
      }
      return response;
    } catch (e) {
      console.log((e as Error).message);
    }
    return Promise.resolve();
  };

  const OnSchemeDeSelection_ = (scId: number) => {
    const schemeList = schemeParams?.filter((val) => val.SchemeID != scId);
    setSchemeParams(schemeList);
    OnSchemeDeSelection(scId);
  }

  const handleSubmit = async () => {
    let shouldReturn = false;
    if (!invAmountValidation() || !SIPDataValidation()) shouldReturn = true;
    const data: any = [];
    schemeParams?.map((item) => {
      const obj = {
        SchemeID: item.SchemeID,
        InvestmentAmount: item.switchValue === 'SIP' ? item.instalmentAmount : item.invAmount,
        SchemeType: item.switchValue === 'SIP' ? 'ISIP' : 'New',
        rmID: rmId,
        ClientCode: investorId,
        No_of_Installments: item.switchValue === 'SIP' ? item.instalments : null,
        SIP_date: item.switchValue === 'SIP' ? item.SIPDay : "",
        Frequency: item.switchValue === 'SIP' ? item.frequency : null,
        AccountID: item.selectedAccount,
        ToSchemeID: "",
        Folio: "",
        Units: 0
      }
      data.push(obj);
      console.log(validations)

    })
    const recommendationData = {
      recommendation_data: data
    }
    if (shouldReturn == true) return;
    await postRecommendedSchemes(recommendationData);
    setIsLoading(false);
  }

  async function postRecommendedSchemes(data: any) {
    let isComponentActive = true;
    (async function () {
      try {
        setIsLoading(true);
        const response = (await dispatch(
          post_recommended_schemes(data)
        )) as unknown as any;
        if (!isComponentActive) {
          return;
        }
        setIsLoading(false);
        isRecommended(true);

      } catch (e) {
        console.log((e as Error).message);
        setIsLoading(false);
      }
    })();

    return () => {
      isComponentActive = false;
    };
  }


  const SIPDataValidation = () => {
    const updatedData = schemeParams ? [...schemeParams] : [];
    let valid = true;
    updatedData?.map((item) => {
      const currentSIPValidation = SIPInstallment?.find((i: any) => i.Productcode_RTA == item.Sch);
      if (item.switchValue === 'SIP') {
        if (item.selectedAccount == "") {
          item.errorAccountSIP = true;
          item.errorMessageAccount = "Account can not be empty";
          valid = false;
        }
        else {
          item.errorAccountSIP = false;
        }
        if (item.instalmentAmount === null || item.instalmentAmount === 0) {
          item.errorInstalmentAmount = true;
          item.errorMessageInstalmentAmount = "Instalment Amount can not be empty";
          valid = false;
        }
        else if (item.instalmentAmount && (item.instalmentAmount < Number(currentSIPValidation?.SIPMINIMUMINSTALLMENTAMOUNT) || item.instalmentAmount > Number(currentSIPValidation?.SIPMAXIMUMINSTALLMENTAMOUNT))) {
          item.errorInstalmentAmount = true;
          item.errorMessageInstalmentAmount = `Please enter amount greater than ${currentSIPValidation?.SIPMINIMUMINSTALLMENTAMOUNT} or less than ${currentSIPValidation?.SIPMAXIMUMINSTALLMENTAMOUNT}`;
          valid = false;
        }
        else {
          item.errorInstalmentAmount = false;
        }

        if (item.instalments == null) {
          item.errorInstalment = true;
          item.errorMessageInstalment = "No. of Instalments can not be empty";
          valid = false;
        }
        else if (item.instalments && (item.instalments < Number(currentSIPValidation?.SIPMINIMUMINSTALLMENTNUMBERS) || item.instalments > Number(currentSIPValidation?.SIPMAXIMUMINSTALLMENTNUMBERS))) {
          item.errorInstalment = true;
          item.errorMessageInstalment = `Please enter amount greater than ${currentSIPValidation?.SIPMINIMUMINSTALLMENTNUMBERS} or less than ${currentSIPValidation?.SIPMAXIMUMINSTALLMENTNUMBERS}`;
          valid = false;
        }
        else {
          item.errorInstalment = false;
        }

        if (item.SIPDay == "") {
          item.errorSIPDay = true;
          item.errorMessageSIPDay = "SIP Day can not be empty";
          valid = false;
        }
        else {
          item.errorSIPDay = false;
        }

        if (item.frequency == null) {
          item.errorFrequency = true;
          item.errorMessageFrequency = "Frequency can not be empty";
          valid = false;
        }
        else {
          item.errorFrequency = false;
        }
      }

    })
    setSchemeParams(updatedData);
    return valid;
  }
  //   const newSchemeParamsData: any[] = selectedSchemes?.map((ele: any) => {
  //     return { ...ele,selectedAccount:""}
  // })

  const isDateDisabled = (date: Date, Sch: string): boolean => {

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (date < currentDate) {
      return false;
    }

    const foundArray = validations.filter((value: any) => {
      return Object.keys(value).includes(Sch)
    })

    const foundValue: any = foundArray[0][Sch]?.find((val: any) => val.SIPFREQUENCY == schemeParams?.find((data) => data.Sch === Sch)?.frequency);
    const datesArray: any = foundValue?.SIPDATES.split(',');

    if (datesArray.includes(date.getDate().toString())) {
      return true;
    } else {
      return false;
    }
  };

  const invAmountValidation = () => {
    const updatedData = schemeParams ? [...schemeParams] : [];
    let valid = true;
    updatedData?.map((item) => {
      if (item.switchValue !== 'SIP') {
        if (item.selectedAccount == "") {
          item.errorAccountLumpsum = true;
          item.errorMessageAccount = "Account can not be empty";
          valid = false;
        }
        else {
          item.errorAccountLumpsum = false;
        }
        if (item.invAmount == null || item.invAmount == 0) {
          item.error = true;
          item.errorMessage = "Amount can not be empty";
          valid = false;
        }
        else if (item.invAmount && (item.invAmount < item.minPurchase || item.invAmount > item.maxPurchase)) {
          item.error = true;
          item.errorMessage = `Enter Amount between ${item.minPurchase} - ${item.maxPurchase}`;
          valid = false;
          // setError(true);
          // setErrorMessage("Enter Amount more the 1000");
        }
        else {
          item.error = false;
        }
      }
    })
    setSchemeParams(updatedData);
    return valid;
  }

  const changeInsSIPAmt = (schemeId: any, sch: any, FrequencyVal: any) => {
    const currentValidation = validations.find((item: any) => {
      const productCode = Object.keys(item)[0];
      const frequencyMatches = item[productCode].some((entry: any) => entry.SIPFREQUENCY === FrequencyVal);
      return productCode === sch && frequencyMatches;
    });
    const result = currentValidation[sch].filter((item: any) => item.SIPFREQUENCY === FrequencyVal);
    const obj = result[0];
    const updatedData = SIPInstallment?.map((item: any) => {
      if (item.Productcode_RTA === sch) {
        return {
          ...item,
          SIPFREQUENCY: obj.SIPFREQUENCY,
          SIPMINIMUMINSTALLMENTNUMBERS: obj.SIPMINIMUMINSTALLMENTNUMBERS,
          SIPMAXIMUMINSTALLMENTNUMBERS: obj.SIPMAXIMUMINSTALLMENTNUMBERS,
          SIPDATES: obj.SIPDATES,
          SIPMINIMUMINSTALLMENTAMOUNT: obj.SIPMINIMUMINSTALLMENTAMOUNT,
          SIPMAXIMUMINSTALLMENTAMOUNT: obj.SIPMAXIMUMINSTALLMENTAMOUNT
        };
      }

      return item;
    });
    setSIPInstallment(updatedData)
  }

  return (
    <Box>
      <Box sx={{ mb: 3, px: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
          Recommended Schemes
        </Typography>
        <Box onClick={handleModalClose} sx={{ cursor: 'pointer' }}>
          <CloseIcon />
        </Box>
      </Box>
      <Divider />
      {schemeParams?.length === 0 ?
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Typography sx={{ fontSize: 18, color: '#5a7c82', width: '50%', margin: '10% 0% 0% 25%' }}>Please select a scheme</Typography>
        </Box> :
        <Box sx={{
          height: '250px',
          overflowY: `${schemeParams?.length && schemeParams?.length > 1 ? "scroll" : 'hidden'}`
        }}>
          {schemeParams?.map((val: schemeParams, index: any) => {
            const plan = val.Growthoption === 1
              ? "Growth"
              : val.Dividendreinvestment === 1
                ? "Div"
                : val.DividendPayout === 1
                  ? "Div"
                  : "";
            const subPlan = val.Dividendreinvestment === 1
              ? "Reinvestment"
              : val.DividendPayout === 1
                ? "Payout"
                : "";
            const currentSIPValidation = SIPInstallment?.find((i: any) => i.Productcode_RTA == val.Sch);
            return (
              <Box sx={{ px: 2, mb: 6, }} key={index}>
                {/* 1 */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', cursor: 'pointer', my: 2.5 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', width: "30%" }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 500, mb: 0.5 }}>
                      {val.SchemeName}
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: "wrap" }}>
                      {!!val.AssetClassName && (
                        <Bubble text={val.AssetClassName} />
                      )}
                      {!!val.Sub_AssetclassName && (
                        <Bubble text={val.Sub_AssetclassName} />
                      )}
                      {plan && <Bubble text={plan} />}
                      {subPlan ? subPlan.length !== 0 && <Bubble text={subPlan} /> : ""}
                      {subPlan && !!val.Dividendfrequency && (
                        <Bubble text={val.Dividendfrequency} />
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ width: "6%", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: 14, color: '#5a7c82' }}>Returns</Typography>
                    <Typography sx={{ fontSize: 16, color: "rgb(30, 163, 98)" }}>
                      {val.Aum === "0" || !val.Aum
                        ? "NA"
                        : `${Nanprocessor(roundToTwo(Number(val.Sch_Return5Yr)))}%`}
                    </Typography>
                  </Box>


                  {val.switchValue !== 'SIP' ?
                    <>
                      <Box sx={{ width: "15%", display: 'flex', flexDirection: 'column', alignItems: "flex-start", justifyContent: "flex-end" }}>
                        <Typography sx={{ fontSize: 14, color: '#5a7c82' }}> Select Account</Typography>
                        <FormControl fullWidth sx={{ mt: 0.5 }}>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={val.selectedAccount}
                            onChange={(e) => {
                              schemeParams[index].selectedAccount = e.target.value;
                              setSchemeParams([...schemeParams])
                              setSelectedAccountType(e.target.value as string)

                            }}
                            sx={{
                              border: "none",
                              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              // width: "10rem",
                              height: '2rem',
                              borderRadius: '5px',
                              padding: '2px 3px',
                              fontSize: 15,
                            }}
                          >
                            {
                              accountType?.account_type[0]?.map((i: any, index: any) => (
                                <MenuItem key={index} value={i.AccountId}> {i.AccountType}</MenuItem>))
                            }
                          </Select>
                        </FormControl>
                        {val.errorAccountLumpsum && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5, ml: 1 }}> {val.errorMessageAccount} </Typography>}
                      </Box>
                      {/* investment amount */}
                      <Box sx={{ width: "15%", display: 'flex', flexDirection: 'column', alignItems: "flex-start", justifyContent: "flex-end", marginRight: "1rem" }}>
                        <Typography sx={{ fontSize: 14, color: '#5a7c82', mb: 0.5 }}>{`Investment Amount`}</Typography>
                        <input style={{
                          // width: "10rem",
                          border: "1px solid #C4C4C4", height: '2rem',
                          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                        }} type="text" className='investmentAmount' placeholder={`Min. - Rs. ₹${val.minPurchase}`} value={val.invAmount}
                          onChange={(e) => {
                            // if (!isNaN(Number(e.target.value))) {
                            const updatedData = [...schemeParams];
                            const objectToUpdate = updatedData.find(item =>
                              item.SchemeID === val.SchemeID
                            );

                            if (objectToUpdate) {
                              objectToUpdate.invAmount = !isNaN(Number(e.target.value)) ? Number(e.target.value) : 0;
                              setSchemeParams(updatedData);
                            }
                            // }
                          }}>
                        </input>

                        {val.error && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5 }}> {val.errorMessage} </Typography>}
                      </Box></>
                    : <>
                      {/* Account Type */}
                      <Box sx={{ width: "15%", display: 'flex', flexDirection: 'column', alignItems: "flex-start", justifyContent: "flex-end" }}>
                        <Typography sx={{ fontSize: 14, color: '#5a7c82' }}> Select Account</Typography>
                        <FormControl fullWidth sx={{ mt: 0.5 }}>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={val.selectedAccount}
                            onChange={(e) => {
                              schemeParams[index].selectedAccount = e.target.value;
                              setSchemeParams([...schemeParams])
                              setSelectedAccountType(e.target.value as string)

                            }}

                            sx={{
                              border: "none",
                              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              // width: "10rem",
                              height: '2rem',
                              borderRadius: '5px',
                              padding: '2px 3px',
                              fontSize: 15,

                            }}
                          >
                            {
                              accountType?.account_type[0]?.map((i: any, index: any) => (
                                <MenuItem key={index} value={i.AccountId}> {i.AccountType}</MenuItem>))
                            }
                          </Select>
                        </FormControl>
                        {val.errorAccountSIP && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5, ml: 1 }}> {val.errorMessageAccount} </Typography>}
                      </Box>
                      {/* // Frequency */}
                      <Box sx={{ width: "15%", display: 'flex', flexDirection: 'column', alignItems: "flex-start", justifyContent: "flex-end", marginRight: "1rem" }}>
                        <Typography sx={{ fontSize: 14, color: '#5a7c82', mb: 0.5 }}>Frequency</Typography>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={val.frequency}
                            onChange={(e) => {
                              const updatedData = [...schemeParams];
                              const objectToUpdate = updatedData.find(item =>
                                item.SchemeID === val.SchemeID
                              );

                              if (objectToUpdate) {
                                objectToUpdate.frequency = e.target.value;
                                setSchemeParams(updatedData);
                              }
                              changeInsSIPAmt(val.SchemeID, val.Sch, e.target.value);
                            }}
                            sx={{
                              border: "none",
                              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              // width: "10rem",
                              height: '2rem',
                              borderRadius: '5px',
                              padding: '2px 3px',
                              fontSize: 15,
                            }}
                          >
                            {validations.find((entry: any) => entry[val.Sch])?.[val.Sch]?.map((item: any, index: any) => (
                              <MenuItem key={index} value={item.SIPFREQUENCY}>{item.SIPFREQUENCY}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {val.errorFrequency && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5 }}> {val.errorMessageFrequency} </Typography>}
                      </Box></>
                  }
                  <Box sx={{ width: "15%", display: 'flex', alignItems: 'flex-end', justifyContent: 'center', p: 3 }}>
                    <Typography
                      sx={{
                        color: '#22242C',
                        opacity: 0.8,
                        fontSize: 14,
                      }}>
                      SIP
                    </Typography>
                    <Switch
                      checked={val.switchValue === 'Lumpsum'}
                      onChange={(_, checked) => {
                        setSelectedAccountType("")
                        const updatedData = [...schemeParams];
                        const objectToUpdate = updatedData.find(item => item.SchemeID === val.SchemeID);
                        const mapToDoubleDigit = (number: any): string => {
                          return number < 9 ? `0${number + 1}` : `${number + 1}`;
                        };
                        const mapDayToDoubleDigit = (number: any): string => {
                          return number <= 9 ? `0${number}` : `${number}`;
                        };

                        setSchemeParams([...schemeParams])
                        if (objectToUpdate) {
                          const date = new Date();
                          objectToUpdate.switchValue = (checked ? 'Lumpsum' : 'SIP');
                          objectToUpdate.SIPDay = checked ? "" : `${mapDayToDoubleDigit(date?.getDate())}/${mapToDoubleDigit(date?.getMonth())}/${date?.getFullYear()}`
                          objectToUpdate.datePicker = checked ? null : date;
                          updatedData[index].selectedAccount = "";
                          updatedData[index].invAmount = 0;
                          setSchemeParams(updatedData);
                        }
                      }
                      }
                      sx={{
                        p: 0,
                        mx: 2,
                        height: 20,
                        width: 43,
                        '& .MuiSwitch-track': {
                          background: '#4990F0',
                          opacity: 1,
                          borderRadius: '12px',
                        },
                        '& .MuiSwitch-thumb': { border: '1px solid #E1D8D8' },
                        '& .MuiSwitch-switchBase': {
                          p: 0,
                          '&.Mui-checked': {
                            color: '#fff',
                            transform: 'translateX(32px)',
                            '& + .MuiSwitch-track': {
                              backgroundColor: '#4990F0',
                              opacity: 1,
                            },
                          },
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        color: '#22242C',
                        opacity: 0.8,
                        fontSize: 14
                      }}>
                      Lumpsum
                    </Typography>
                  </Box>
                  <Box sx={{ width: "5%", display: 'flex', alignItems: "center", justifyContent: "flex-end", p: 2, ml: 1 }}>
                    <div onClick={() => { OnSchemeDeSelection_(val.SchemeID); }}><DeleteIcon /></div>
                  </Box>
                </Box>
                {/* 2 */}
                {
                  val.switchValue === 'SIP' ? <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', my: 2.5 }}>

                    {schemeParams.find(item =>
                      item.SchemeID === val.SchemeID
                    )?.frequency != null ?
                      <>
                        {/* Instalment Amount */}
                        <Box sx={{ width: "34%", display: 'flex', flexDirection: 'column', alignItems: "flex-start" }}>
                          <Typography sx={{ fontSize: 14, color: '#5a7c82', mb: 0.5 }}>{`Instalment Amount`}</Typography>
                          <input style={{
                            width: "15rem", height: '2rem', border: "1px solid #C4C4C4",
                            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                          }} type="text" className='investmentAmount' placeholder={`Min. - Rs. ₹${currentSIPValidation?.SIPMINIMUMINSTALLMENTAMOUNT}`} value={val.instalmentAmount}
                            onChange={(e) => {
                              // if (!isNaN(Number(e.target.value))) {
                              const updatedData = [...schemeParams];
                              const objectToUpdate = updatedData.find(item =>
                                item.SchemeID === val.SchemeID
                              );

                              if (objectToUpdate) {
                                objectToUpdate.instalmentAmount = !isNaN(Number(e.target.value)) ? Number(e.target.value) : 0;
                                setSchemeParams(updatedData);
                              }
                              // }
                            }}>
                          </input>
                          {val.errorInstalmentAmount && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5 }}> {val.errorMessageInstalmentAmount} </Typography>}
                        </Box>
                        {/* No. of instalments */}
                        <Box sx={{ width: "34%", display: 'flex', flexDirection: 'column', alignItems: "flex-start" }}>
                          <Typography sx={{ fontSize: 14, color: '#5a7c82', mb: 0.5 }}>No. of Instalments</Typography>
                          <input style={{
                            width: "15rem", border: "1px solid #C4C4C4",
                            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                          }} type="text" className='investmentAmount2' placeholder={`Enter Number ${currentSIPValidation?.SIPMINIMUMINSTALLMENTNUMBERS} - ${currentSIPValidation?.SIPMAXIMUMINSTALLMENTNUMBERS}`} value={val.instalments}
                            onChange={(e) => {
                              // if (!isNaN(Number(e.target.value))) {
                              const updatedData = [...schemeParams];
                              const objectToUpdate = updatedData.find(item =>
                                item.SchemeID === val.SchemeID
                              );

                              if (objectToUpdate) {
                                objectToUpdate.instalments = !isNaN(Number(e.target.value)) ? Number(e.target.value) : 0;
                                setSchemeParams(updatedData);
                              }
                              // }
                            }}>
                          </input>
                          {val.errorInstalment && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5 }}> {val.errorMessageInstalment} </Typography>}
                        </Box>
                        {/* SIP Day */}
                        <Box sx={{ width: "34%", display: 'flex', flexDirection: 'column', alignItems: "flex-start" }}>
                          <Typography sx={{ fontSize: 14, color: '#5a7c82', mb: 0.5 }}>SIP Day</Typography>
                          <DatePicker
                            className="custom-datepicker"
                            // ref={datePickerRef}
                            selected={val.datePicker}
                            onChange={(date: Date) => {
                              const updatedData = [...schemeParams];
                              const objectToUpdate = updatedData.find(item =>
                                item.SchemeID === val.SchemeID
                              );
                              const mapToDoubleDigit = (number: number): string => {
                                return number < 9 ? `0${number + 1}` : `${number + 1}`;
                              };
                              const mapDayToDoubleDigit = (number: any): string => {
                                return number <= 9 ? `0${number}` : `${number}`;
                              };
                              if (objectToUpdate) {
                                objectToUpdate.SIPDay = `${mapDayToDoubleDigit(date?.getDate())}/${mapToDoubleDigit(date?.getMonth())}/${date?.getFullYear()}`
                                objectToUpdate.datePicker = date
                                setSchemeParams(updatedData);
                              }
                            }}
                            dateFormat="dd-MM-yyyy"
                            filterDate={(date: Date) => isDateDisabled(date, val.Sch)}
                          // customInput={<CustomInput />}

                          />
                          {val.errorSIPDay && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5 }}> {val.errorMessageSIPDay} </Typography>}
                        </Box>
                      </> : <></>}

                    {/* Mandate */}
                    {/* <Box sx={{ width: "24%", display: 'flex', flexDirection: 'column', alignItems: "flex-start" }}>
                    <Typography sx={{ fontSize: 14, color: '#5a7c82', mb: 0.5 }}>Mandate</Typography>
                    <input type="" className='investmentAmount2' value={val.mandate}
                      onChange={(e) => {
                        const updatedData = [...schemeParams];
                        const objectToUpdate = updatedData.find(item =>
                          item.SchemeID === val.SchemeID
                        );

                        if (objectToUpdate) {
                          objectToUpdate.mandate = e.target.value;
                          setSchemeParams(updatedData);
                        }
                      }}>
                    </input>
                    {val.error && <Typography sx={{ fontSize: 10, color: 'red', mb: 0.5 }}> {val.errorMessage} </Typography>}
                    </Box>*/}
                  </Box> : <></>
                }
              </Box>
            )
          })
          }
        </Box>}
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 4 }}>
        {schemeParams?.length !== 0 ? <Button
          sx={{
            height: '40px',
            color: 'white',
            fontSize: '16px',
            fontWeight: 400,
            cursor: 'pointer',
            borderRadius: '5px',
            bgcolor: '#337FC9',
            width: '50%',
            '&:hover': { backgroundColor: '#337FC9' },
          }}
          onClick={handleSubmit}
        // alert(JSON.stringify(schemeParams))
        >{isLoading ? <CircularProgress sx={{ color: 'white' }} /> : "Recommend"}</Button>
          : <></>}
      </Box>
    </Box >
  )
}

export function PerformaneAnalysisChart(
  { yearSelected, graphArray, categoryAverageArray }:
    {
      yearSelected: any;
      graphArray: any;
      categoryAverageArray: any;
    }
) {

  const [portfolioPerformanceGraphOption, setPortfolioPerformanceGraphOption] = useState<any>({
    chart: {
      type: "line",
      zoomType: "x",
      resetZoomButton: {
        theme: {
          display: "none",
        },
      },

      height: 200,
    },
    title: {
      text: "",
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      type: "datetime",
      tickInterval: 24 * 60 * 60 * 1000 * 30 * 6,

      dateTimeLabelFormats: {
        day: "%b '%y",
      },
    },

    visible: false,

    series: [
      {
        type: "area",
        data: [],
      },
    ],
  });

  useEffect(() => {
    getInitialValue(graphArray, categoryAverageArray, yearSelected);
  }, [graphArray, yearSelected, categoryAverageArray])

  function getInitialValue(arrResult: any, cvgArr: any, year: any) {
    if (arrResult && arrResult.length > 0) {
      let maxDate: Date | number = new Date();
      maxDate = maxDate.setFullYear(maxDate.getFullYear());
      let minDate: Date | number = new Date();
      let _lableCount = 3;
      let _valueFormmater = "yyyy";
      let _timeInterval: string | number = "";

      switch (year) {
        case "1Y":
          minDate = minDate.setFullYear(minDate.getFullYear() - 1);
          _lableCount = 6;
          _valueFormmater = "MMM yy";
          _timeInterval = 24 * 60 * 60 * 1000 * 20;
          break;
        case "3Y":
          minDate = minDate.setFullYear(minDate.getFullYear() - 3);
          _lableCount = 6;
          _valueFormmater = "MMM yy";
          _timeInterval = 24 * 60 * 60 * 1000 * 30 * 3;
          break;
        case "7Y":
          minDate = minDate.setFullYear(minDate.getFullYear() - 7);
          _lableCount = 3;
          _valueFormmater = "yyyy";
          _timeInterval = 24 * 60 * 60 * 1000 * 30 * 6;
          break;
        case "5Y":
          minDate = minDate.setFullYear(minDate.getFullYear() - 5);
          _lableCount = 3;
          _valueFormmater = "yyyy";
          _timeInterval = 24 * 60 * 60 * 1000 * 30 * 6;
          break;
        case "10Y":
          minDate = minDate.setFullYear(minDate.getFullYear() - 10);
          _lableCount = 3;
          _valueFormmater = "yyyy";
          _timeInterval = 24 * 60 * 60 * 1000 * 30 * 6;
          break;
        case "1M":
          minDate = new Date(
            minDate.setMonth(minDate.getMonth() - 1)
          ).getTime();
          _lableCount = 3;
          _valueFormmater = "yyyy";
          _timeInterval = 24 * 60 * 60 * 1000 * 5;
          break;
        case "3M":
          minDate = new Date(
            minDate.setMonth(minDate.getMonth() - 3)
          ).getTime();
          _lableCount = 3;
          _valueFormmater = "yyyy";
          _timeInterval = 24 * 60 * 60 * 1000 * 20;
          break;

        case "6M":
          minDate = new Date(
            minDate.setMonth(minDate.getMonth() - 6)
          ).getTime();
          _lableCount = 3;
          _valueFormmater = "yyyy";
          _timeInterval = 24 * 60 * 60 * 1000 * 20;
          break;
        default:
          minDate = minDate.setFullYear(minDate.getFullYear() - 1);
          _lableCount = 3;
          _valueFormmater = "yyyy";
          _timeInterval = 24 * 60 * 60 * 1000 * 30 * 6;
          break;
      }

      const result = arrResult.filter(
        (a: any) => new Date(a.x) > minDate && new Date(a.x) < maxDate
      );

      const cvg_result = cvgArr.filter(
        (a: any) => new Date(a.x) > minDate && new Date(a.x) < maxDate
      );
      // var myDate = !!result.length ? result[0].x : "";

      // const map1 = arrResult.map((ele) => new Date(ele.x));

      setPortfolioPerformanceGraphOption(
        {
          series: [
            {
              type: "area",
              name: "NAV",
              threshold: null,
              data: result.map(Object.values),
              color: "#2b4a76",
              lineColor: "#2b4a76",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0.21, "#d7e4f4"],
                  [1, "#d7e4f4"],
                ],
              },
            },
            {
              type: "area",
              name: "CVG",
              threshold: null,
              data: cvg_result.map(Object.values),
              color: "#FFA500",
              lineColor: "#FFA500",
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0.21, "rgba(255, 165, 0,0.5)"],
                  [1, "rgba(255, 165, 0,0.3)"],
                ],
              },
            }
          ],
          credits: {
            enabled: false,
          },

          xAxis: {
            type: "datetime",
            tickInterval: _timeInterval,
            title: {
              text: null,
            },
            dateTimeLabelFormats: {
              day: "%b '%y",
            },
          },
          tooltip: {
            split: false,
            color: "red",

            formatter: function (this: Highcharts.Point): any {
              const formatter = new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
              });

              return (
                // "NAV :" +
                formatter.format(this.y ? this.y : 0) +
                "<br>" +
                new Date(this.x).toLocaleDateString("en-UK", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }) +
                "</br>"
              );
            },
          },

          caption: {
            text: null,
          },
          title: {
            text: null,
          },
          chart: {
            type: "line",
            zoomType: "x",
            resetZoomButton: {
              theme: {
                display: "none",
              },
            },

            height: 200,
          },

          legend: {
            enabled: false,
          },
          plotOptions: {
            series: {
              marker: {
                enabled: false,
              },
              compare: 'percent',
            },
            area: {
              lineWidth: 1,
            },
          },
          yAxis: {
            min: 0,
            gridLineColor: null,

            title: {
              text: null,
            },
            labels: {
              enabled: false,
            },
          },
        }
      )
    }
  }
  // const portfolioPerformaceGraphOptions = {
  //   chart: {
  //     type: 'area',
  //     // scrollablePlotArea: {
  //     //   minWidth: 600,
  //     //   scrollPositionX: 1,
  //     // },
  //   },
  //   title: {
  //     text: '',
  //   },
  //   credits: false,
  //   xAxis: {
  //     // type: 'datetime',
  //     categories: portfolioPerformance?.map(
  //       (each: { DT: string }) =>
  //         formatLongDate(each.DT).split(' ')[1].substring(0, 3) +
  //         ' ' +
  //         formatLongDate(each.DT).split(' ')[2]
  //     ),
  //     labels: {
  //       autoRotation: false,
  //       overflow: 'justify',
  //     },
  //   },
  //   yAxis: {
  //     title: {
  //       text: 'Return',
  //     },
  //     labels: {
  //       // formatter: function (): string {
  //       //   return '<span>' + (this as any).value + ' %</span>';
  //       // },
  //       format: '{text} %',
  //     },
  //     visible: false
  //   },
  //   tooltip: {
  //     valueSuffix: ' %',
  //     shared: true,
  //   },
  //   legend: {
  //     align: 'center',
  //     verticalAlign: 'top',
  //     enabled: false,
  //   },
  //   plotOptions: {
  //     line: {
  //       lineWidth: 2,
  //       states: {
  //         hover: {
  //           lineWidth: 3,
  //         },
  //       },
  //       marker: {
  //         enabled: false,
  //       },
  //     },
  //   },
  //   series: [
  //     {
  //       name: 'Portfolio',
  //       color: '#337FC9',
  //       opacity: '0.5',
  //       outerHeight: '200px',
  //       data: portfolioPerformance?.map((each: { Rtn: any; }) => each.Rtn),
  //       connectEnds: false,
  //       connectNulls: true,
  //       crisp: true,
  //     },
  //     // {
  //     //   name: 'Sensex',
  //     //   color: '#F4C10E',
  //     //   data: portfolioPerformance?.map((each) => 0),
  //     // },
  //     // {
  //     //   name: 'Nifty',
  //     //   color: '#730EF4',
  //     //   data: portfolioPerformance?.map((each) => 0),
  //     // },
  //   ],
  //   navigation: {
  //     menuItemStyle: {
  //       fontSize: '8px',
  //     },
  //   },
  // };
  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        options={portfolioPerformanceGraphOption}
      />
    </>
  )
}

